/* eslint-disable ember/no-computed-properties-in-native-classes */
import Controller from '@ember/controller';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class SubjectController extends Controller {
  // Services
  @service
  options;

  @service
  session;

  @service
  store;

  @alias('model.group.currentLearners.length')
  numLearners;

  @alias('model.group.id')
  groupId;

  @optionAlias('hero:lock:milestones')
  milestonesLocked;

  @alias('features.sidekickEnabled')
  sidekickEnabled;
}
